import { atom } from 'recoil';
import { UserSummary } from '../interfaces/User/UserSummary';

export const userSummaryAtom = atom<UserSummary | undefined>({
  key: 'userSummaryState',
  default: undefined,
});
